// Modules
import { signIn, signOut } from "next-auth/react";
// Helpers
import { encrypt } from "../../../helpers/auth";
import { cleanCache } from "../../../helpers/swr";

/**
 * Signins a user by email and password.
 *
 * @param {String} email the email
 * @param {String} password the password
 * @returns the result of signin call
 */
export async function login(email, password) {
    const encryptedPassword = password && (await encrypt(password));

    const result = await signIn("credentials", {
        redirect: false,
        email: email.toLowerCase(),
        password: encryptedPassword
    });

    return result;
}

/**
 * Sign out the logged in user.
 *
 * @param {Object} swrConfig the swr configuration
 */
export function logout(swrConfig) {
    try {
        signOut({ redirect: false });
        cleanCache(swrConfig);
    } catch (err) {
        console.error(err);
    }
}
